import {DisplayProfile, ProfileItemSection} from '../../../types';
import {DialogTabProps} from '../Tabbed/TabbedDialog';
import {useProfileStore} from '../../../store/profileStore.ts';
import React from 'react';
import AttributeDefinitionTransferList from './Transfer/AttributeDefinitionTransferList.tsx';
import {
    useIndexById,
    useAttributeDefinitionStore,
} from '../../../store/attributeDefinitionStore.ts';
import {useTranslation} from 'react-i18next';
import {FullPageLoader} from '@alchemy/phrasea-ui';
import {Button} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

type Props = {
    id: string;
    data: DisplayProfile;
} & DialogTabProps;

export default function OrganizeProfile({data, onClose, minHeight}: Props) {
    const {t} = useTranslation();

    const load = useAttributeDefinitionStore(state => state.load);

    React.useEffect(() => {
        load();
    }, [load]);

    const {allDefinitions, loaded} = useAttributeDefinitionStore(state => ({
        definitions: state.definitions,
        loaded: state.loaded,
        allDefinitions: [...state.builtIn, ...state.definitions],
    }));
    const definitionsIndex = useIndexById(true);

    const {sortList, removeFromList, addToList} = useProfileStore(state => ({
        sortList: state.sortList,
        removeFromList: state.removeFromProfile,
        addToList: state.addToList,
    }));

    if (!loaded || !data.items) {
        return <FullPageLoader />;
    }

    const attributeItems = data.items.filter(
        i => i.section === ProfileItemSection.Attributes
    );

    return (
        <>
            <DialogContent
                sx={{
                    minHeight,
                }}
            >
                <AttributeDefinitionTransferList
                    listId={data.id}
                    definitions={allDefinitions}
                    definitionsIndex={definitionsIndex}
                    list={attributeItems}
                    onSort={items => {
                        sortList(data.id, items);
                    }}
                    onAdd={items => {
                        addToList(data.id, items);
                    }}
                    onRemove={items => {
                        removeFromList(data.id, items);
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('dialog.close', 'Close')}</Button>
            </DialogActions>
        </>
    );
}
